<template>
    <v-text-field
        ref="txtArea"
        @input="handleInput"
        @paste="
            (evt) => $validateOnlyNumbers(evt, true, idioma)
        "
        @click="
            parseString(input.valor, idioma) === 0
            ? (input.valor = '')
            : ''
        "
        @keypress="(val) => onlyFloat(val, input, 'valor')"
        @change="
            (evt) => {
            limpezaDeDados(input, 0, calculo1, [animal]);
            }
        "
        :value="value"
        style="border: 1px solid #000"
        :label="lbl"
        :outline="outline"
        :lang="idioma === 0 ? 'pt-br' : (idioma === 1) ? 'en-us' : 'es-ES'"
        pattern="\d*"
        inputmode="decimal"
        />
</template>
<script>
export default {
  props: {
    label: String,
    value: String,
    outline: {
      type: Boolean,
      default: false
    },
    idioma: {
        type: Number,
        default: 0
    }
  },
  data () {
    return {
      content: this.value,
      lbl: this.label
    }
  },
  methods: {
    handleInput (e) {
      this.$emit('input', e)
    }
  }
}
</script>